import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Redirect } from 'react-router'
import moment from '../../helpers/moment'
import qs from 'query-string'

import Notifications from '../../components/notifications/notifications'
import PoolsIndex from '../pools/index'
import PoolDetails from '../pools/details/index'
import PoolsAdd from '../pools/add'
import RestaurantsSearch from '../restaurants/search'
import RestaurantDetails from '../restaurants/details/index'
import RestaurantPoolSchedule from '../restaurant-pool-schedule'
import Header from '../../components/header'
import LoginCallback from '../login/Callback'
import IsAuthenticated from '../login/IsAuthenticated'
import DeletePoolModal from '../modal/deletePool'
import UpdateBestGuessModal from '../modal/updateBestGuess'
import UpdatePoolThresholdsModal from '../modal/updatePoolThresholds'
import SyncPartnerRestaurantsDetailsModal from '../modal/syncPartnerRestaurantsDetails'
import ManuallyChangePoolStatusModal from '../modal/manuallyChangePoolStatus'
import {JETMS} from "@jet/jetms-client-sdk/dist/window"
import { HIDE_POOL_SHIFTS } from '../../constants/featureFlags'

class App extends React.Component {
  render() {

    const body = () => {
      return <div>
        <main>
          <Route exact path="/" render={() => (<Redirect to="/pools" />)} />
          <Switch>
            <Route exact path="/pools" component={PoolsIndex} />
            <Route exact path="/pools/add" component={PoolsAdd} />
            <Route exact path="/pools/create" component={PoolsAdd} />
            <Route exact path="/pools/:id" render={(props) =>
              <Redirect to={{
                pathname: HIDE_POOL_SHIFTS
                  ? `${props.location.pathname}/info`
                  : `${props.location.pathname}/shifts/${moment(new Date()).format('YYYY-MM-DD')}`,
                search: props.location.search
              }} />
            } />
            {HIDE_POOL_SHIFTS && (
              <Route path="/pools/:id/shifts" render={(props) =>
                <Redirect to={{
                  pathname: props.location.pathname.replace(/\/shifts.*/, '/info'),
                  search: props.location.search
                }} />
              } />
            )}
            <Route exact path="/pools/:id/shifts/:activeDate?" render={(props) => (
              <PoolDetails {...props} selectedTab={'shifts'} />
            )} />
            <Route exact path="/pools/:id/logs" render={(props) => (
              <PoolDetails {...props} selectedTab={'logs'} />
            )} />
            <Route exact path="/pools/:id/summary" render={(props) => (
              <PoolDetails {...props} selectedTab={'summary'} />
            )} />
            <Route exact path="/pools/:id/restaurants" render={(props) => (
              <PoolDetails {...props} selectedTab={'restaurants'} />
            )} />
            <Route exact path="/pools/:id/info" render={(props) => (
              <PoolDetails {...props} selectedTab={'info'} />
            )} />
            <Route exact path="/pools/:id/deliveryHours" render={(props) => (
              <PoolDetails {...props} selectedTab={'deliveryHours'} />
            )} />
            <Route exact path="/restaurants" render={() =>
              <Redirect to="/restaurants/search" />
            } />
            <Route exact path="/restaurants/search" render={(props) => {
              let parsedQueryString = qs.parse(props.location.search)
              return <RestaurantsSearch searchText={parsedQueryString.q} searchType={parsedQueryString.qt} page={parsedQueryString.page} />
            }} />
            <Route exact path="/restaurants/:id" render={(props) => {
              let restaurantId = parseInt(props.match.params.id, 10)
              return <RestaurantDetails key={restaurantId} restaurantId={restaurantId} selectedTab={'info'} />
            }} />
            <Route exact path="/restaurants/:id/logs" render={(props) => {
              let restaurantId = parseInt(props.match.params.id, 10)
              return <RestaurantDetails key={restaurantId} restaurantId={restaurantId} selectedTab={'logs'} />
            }} />
            <Route exact path="/restaurants/:id/summary" render={(props) => {
              let restaurantId = parseInt(props.match.params.id, 10)
              return <RestaurantDetails key={restaurantId} restaurantId={restaurantId} selectedTab={'summary'} />
            }} />
            <Route path="/restaurant-pool-schedule" render={(props) => (
              <RestaurantPoolSchedule {...props} />
            )} />
          </Switch>
        </main>
        <Notifications />
      </div>
    }

    const wrappedBody = () => {
      if (typeof JETMS === "undefined") {
        return <IsAuthenticated>{body()}</IsAuthenticated>
      } else {
        return body()
      }
    }


    return <div>
      { typeof JETMS === "undefined" && <Route exact path="/login/callback" component={LoginCallback} /> }
      { typeof JETMS === "undefined" && <Header /> }
      { wrappedBody() }
      <DeletePoolModal />
      <UpdateBestGuessModal />
      <UpdatePoolThresholdsModal />
      <SyncPartnerRestaurantsDetailsModal />
      <ManuallyChangePoolStatusModal />
    </div>
  }
}
export default App



// WEBPACK FOOTER //
// ./src/containers/app/index.js